import React, { useState } from 'react';
import axios from '../api/axios';

const URLCrawler = () => {

    const [url, setUrl] = useState('');
    const [result, setResult] = useState(null);

    const handleCrawler = async (e) => {
        try {
            const response = await axios.get('https://url-fetcher.gv-one.com/load-data-from-url?url=' + url);
            console.log('response :>> ', response);
            setResult(response.data);
        } catch (error) {
            console.log('error :>> ', error);
            // Working on sample
            // setResult(
            //     { "title": "2023 Bridge Conference", "description": "", "listOfImages": ["https://www.eventscribe.com/upload/planner/bannersNEW/Bridge23_Banners_Top_2340x280_01_54.jpg", "https://9705d30458bee754b9eb-9c88e3975417fd6766d9db3e7b2c798a.ssl.cf1.rackcdn.com/18676-0-Artwork400x400LeftBanner_0.2687799(1).jpg", "https://cdmcd.co/zEgm7g", "https://cdmcd.co/KpxqKz"], "mostUsedColors": ["#181e4e", "#ffffff", "#7071e5", "#cacaca"], "screenshotImage": null }
            // );
        }

    }

    return (
        <div style={{ maxWidth: '500px' }}>
            <div className="input-group mb-3">
                <input type="text"
                    className="form-control"
                    placeholder="Enter Your URL"
                    aria-label="Enter Your URL"
                    onChange={(e) => { setUrl(e.target.value) }}
                    value={url} />
                <button className="btn btn-outline-primary" type="button" onClick={handleCrawler}>Go</button>
            </div>
            {result &&
                <>
                    {result?.listOfImages &&
                        <>
                            <h6>Images</h6>
                            <div className='row g-2 mb-3'>
                                {
                                    result.listOfImages.map((image, i) => (
                                        <div key={`Image${i}`} className='col'>
                                            <img alt='Sample' src={image} className='img-fluid img-thumbnail' />
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    }
                    {result?.mostUsedColors &&
                        <>
                            <h6>Colors</h6>
                            <div className='hstack gap-3'>
                                {
                                    result.mostUsedColors.map((color, i) => (
                                        <div key={`Color${i}`} className='img-thumbnail' style={{
                                            width: '30px',
                                            height: '30px',
                                            backgroundColor: color
                                        }}>
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    }
                </>
            }
        </div>
    )
}

export default URLCrawler
